import { formatDateTime, uId } from "common/utility"
import { getOrderLog } from "http/order/order"
import React, { useEffect, useState } from "react"
import {
  Button,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader
} from "reactstrap"

const TrackOrder = props => {

  const { isOpen, orderId, toggle } = props
  const [length, setLength] = useState(0)
  const [statuses, setStatuses] = useState([])

  useEffect(() => {
      getOrderLog({ orderId })
      .then(responseFromApi => {
        setLength(responseFromApi.data.count)
        let newData = responseFromApi.data.rows.map(item => {
          if (item.currStatus == 'pending') {
            return {
              id: 1,
              stausTitle: "Ordered",
              iconClass: "bx-copy-alt",
              description: formatDateTime(item.updatedAt),
              user: `Ordered by ${item.updatedByUser.firstName} ${item.updatedByUser.lastName}`
            }
          } else if (item.currStatus == 'accepted') {
            return {
              id: 2,
              stausTitle: "Accepted",
              iconClass: "bx-package",
              description: formatDateTime(item.updatedAt),
              user: `Accepted by ${item.updatedByUser.firstName} ${item.updatedByUser.lastName}`
            }
          } else if (item.currStatus == 'shipped') {
            return {
              id: 3,
              stausTitle: 'Shipped',
              iconClass: "bx-car",
              description: formatDateTime(item.updatedAt),
              user: `Shipped by ${item.updatedByUser.firstName} ${item.updatedByUser.lastName}`
            }
          } else if (item.currStatus == 'delivered') {
            return {
              id: 4,
              stausTitle: 'Delivered',
              iconClass: "bx-badge-check text-success",
              description: formatDateTime(item.updatedAt),
              user: `Delivered by ${item.updatedByUser.firstName} ${item.updatedByUser.lastName}`
            }
          } else if (item.currStatus == 'rejected') {
            return {
              id: 4,
              stausTitle: 'Rejected',
              iconClass: "bx-badge-check text-danger",
              description: formatDateTime(item.updatedAt),
              user: `Rejected by ${item.updatedByUser.firstName} ${item.updatedByUser.lastName}`
            }
          } else if (item.currStatus == 'cancelled') {
            return {
              id: 5,
              stausTitle: 'Cancelled',
              iconClass: "bx-badge-check text-danger",
              description: formatDateTime(item.updatedAt),
              user: `Cancelled by ${item.updatedByUser.firstName} ${item.updatedByUser.lastName}`
            }
          }
        })
        setStatuses(newData)
      })
      .catch(error => { })
  }, [])
  return (
    <Modal
      isOpen={isOpen}
      role="dialog"
      autoFocus={true}
      centered={true}
      className="exampleModal"
      tabIndex="-1"
      toggle={() => toggle(orderId)}
    >
      <div className="modal-content">
        <ModalHeader toggle={() => toggle(orderId)}>Order Tracking</ModalHeader>
        <ModalBody>
          <div >
            <ul className="verti-timeline list-unstyled">
              {/* Render Horizontal Timeline Events */}
              {statuses.map((status, key) => (
                <li key={uId()} className="event-list">
                  <div className="event-timeline-dot">
                    <i
                      className={
                        key == length - 1
                          ? "bx bx-right-arrow-circle bx-fade-right"
                          : "bx bx-right-arrow-circle"
                      }
                    />
                  </div>
                  <div className="d-flex">
                    <div className="me-3">
                      <i
                        className={
                          "bx " + status.iconClass + " h2 text-primary"
                        }
                      />
                    </div>
                    <div className="flex-grow-1">
                      <div>
                        <h5>{status.stausTitle}</h5>
                        <p className="text-muted">
                          {status.description}
                        </p>
                        <p className="text-muted1">
                          {status.user}
                        </p>
                      </div>
                    </div>
                  </div>
                </li>
              ))}
            </ul>
          </div>
        </ModalBody>
        <ModalFooter>
          <Button type="button" color="secondary" onClick={() => toggle(orderId)}>
            Close
          </Button>
        </ModalFooter>
      </div>
    </Modal>

  )
}

export default TrackOrder